// import { Grid } from "@mui/material";
// import React, { useEffect, useState } from "react";

// import { useNavigate } from "react-router-dom";
// import { IColumns } from "../../Components/DataGrid/WSDataGrid";
// import { IHeaderRows } from "../../Components/Filter/WSHeaderFilter";
// import WSDataGridNew from "../../Components/DataGrid/WSDataGridNew";

// export const RecentPrescriptionOrder: React.FC<any> = React.memo((props) => {
//   const navigate = useNavigate();

//   const filters = [
//     "All",
//     "Pending",
//     "Packed",
//     "Ready to dispatch",
//     "Out for delivery",
//     "Delivered",
//     "cancelled",
//   ];
//   const [selectedFilter, setSelectedFilter] = useState(filters[0]);

//   const columns: IColumns[] = [
//     {
//       header: "Order ID",
//       fieldName: "",
//       type: "default",
//       // sortable: true
//     },
//     {
//       header: "Customer",
//       fieldName: "price",
//       type: "default",
//     },
//     {
//       header: "Uploaded Prescription",
//       fieldName: "mode",
//       type: "default",
//     },

//     {
//       header: "Status",
//       fieldName: "status",
//       type: "status",
//     },
//     {
//       header: "Time",
//       fieldName: "mode",
//       type: "default",
//     },
//     {
//       header: "Actions",
//       fieldName: "actions",
//       type: "action",
//       actions: ["Edit"].filter(Boolean),
//       // actionCallback: (action, row) => handleAction(action, row),
//       // hideSelectedActions: {
//       //     fieldToHide: [
//       //         {
//       //             field: 'status',
//       //             hideValue: ['Incomplete'],
//       //             hideActions: ['Edit']
//       //         },
//       //         // {
//       //         //     field: 'profileStatus',
//       //         //     hideValue: ['Approved'],
//       //         //     hideActions: ['Approve']
//       //         // }
//       //     ]
//       // }
//     },
//   ];
//   const filterRows: IHeaderRows[] = [
//      {
//       label: "All",
//       fieldName: "",
//       type: "dropdown",
//       options: [
//         { label: "All", value: "all" },
//         { label: "Pending", value: "pending" },
//         { label: "Processing", value: "processing" },
//         { label: "Delivered", value: "delivered" },
//       ],
//       operator: "eq",
//       rowDivision: 3,
//     },
//   ];

//   const handleClick = async () => {
//     navigate(`/lab-orders/add`);
//   };
//   return (
//     <>
//       <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//         {
//           <Grid item sm={12}>
//             <WSDataGridNew
//               columns={columns}
//               id="prescriptionOrderListGrid"
//               title="Recent Prescription Order"
//               filterFields={filterRows}
//               addButton={{ label: "New", color: "secondary" }}
//               onAddButtonClick={handleClick}
//               gridHeaderSx={{
//                 backgroundColor: "whitesmoke",
//                 border: "1px solid whitesmoke",
//               }}
//             />
//           </Grid>
//         }
//       </Grid>
//     </>
//   );
// });





import { Grid, Snackbar, Alert, Typography } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import WSDataGridNew, { IColumns } from "../../Components/DataGrid/WSDataGridNew";
import { IHeaderRows } from "../../Components/Filter/WSHeaderFilter";
import { useNavigate } from "react-router-dom";
import http from "../../commonFunctions/httpClient";
import { getLocalValue, LoacalVariables } from "../../commonFunctions/CommonFunctions";

interface RecentPrescriptionOrder {
  id: string;
  orderId: string;
  patientName: string | null;
  price: number;
  itemsCount: number;
  paymentStatus: string;
  orderDate: string;
  status: string;
  prescriptionUrl?: string;
  actions: string;
}

export const RecentPrescriptionOrder: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  
  const [vendorId, setVendorId] = useState<string>("");
  const [prescriptionOrders, setPrescriptionOrders] = useState<RecentPrescriptionOrder[]>([]);
  const [loading, setLoading] = useState(true);

  // Snackbar State
  const [snackbar, setSnackbar] = useState<{ 
    open: boolean; 
    message: string; 
    severity: 'success' | 'error' 
  }>({
    open: false,
    message: '',
    severity: 'success'
  });

  // Get vendorId from localStorage
  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    console.log("🔑 LOADED VENDOR ID:", userId);
    setVendorId(userId || "");
  }, []);

  const fetchPrescriptionOrders = useCallback(async () => {
    if (!vendorId) {
      console.log("⏳ Waiting for vendorId...");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      console.log("📡 FETCHING PRESCRIPTION ORDERS FOR VENDOR:", vendorId);
      const response: any = await http.get(`pharmacy/PrescriptionOrder/ByVendor/${vendorId}`);
      console.log("📦 FULL API RESPONSE:", response);
      
      let data: RecentPrescriptionOrder[] = [];
      if (response && Array.isArray(response.data)) {
        data = response.data.map((order: any) => ({
          id: order.id || order.orderId,
          orderId: `#HC${(order.orderId || order.id || '').slice(-6).toUpperCase()}`,
          patientName: order.patient?.username || order.userName || order.patientName || 'N/A',
          price: order.orderInfo?.subtotal || order.paymentInfo?.orderPrice || order.totalAmount || order.price || 0,
          itemsCount: order.orderInfo?.totalItems || order.itemCount || order.itemsCount || 0,
          paymentStatus: order.paymentInfo?.paymentStatus || order.paymentMethod || order.paymentStatus || 'Unpaid',
          orderDate: order.timeline?.orderPlaced ? new Date(order.timeline.orderPlaced).toLocaleDateString() : 'N/A',
          status: order.timeline?.status || order.status || 'Pending',
          prescriptionUrl: order.prescriptionImage || order.prescriptionUrl || '',
          actions: order.id || order.orderId
        }));
      }
      
      console.log("📦 TRANSFORMED DATA:", data);
      setPrescriptionOrders(data);
    } catch (error: any) {
      console.error("💥 API ERROR:", error);
      setPrescriptionOrders([]);
      setSnackbar({
        open: true,
        message: "Failed to load prescription orders",
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  }, [vendorId]);

  useEffect(() => {
    fetchPrescriptionOrders();
  }, [fetchPrescriptionOrders]);

  // Action Handler
  const handleAction = useCallback((action: string, row: RecentPrescriptionOrder) => {
    console.log("🔧 ACTION:", action, "ROW:", row);
    
    switch (action) {
      case "View":
        navigate(`/prescription-order-details/${row.id}`);
        break;
      case "View Prescription":
        if (row.prescriptionUrl) {
          window.open(row.prescriptionUrl, '_blank');
        }
        break;
      default:
        console.log("Unknown action:", action);
    }
  }, [navigate]);

  const handleAddClick = useCallback(() => {
    navigate(`/prescription-orders/add`);
  }, [navigate]);

  const columns: IColumns[] = [
    { 
      header: "Order ID", 
      fieldName: "orderId", 
      type: "default" 
    },
    { 
      header: "Customer", 
      fieldName: "patientName", 
      type: "default" 
    },
    // { 
    //   header: "Uploaded Prescription", 
    //   fieldName: "prescriptionUrl", 
    //   type: "default" // ✅ Removed renderCell - using simple text display
    // },
    { 
      header: "Price", 
      fieldName: "price", 
      type: "default" 
    },
    { 
      header: "Status", 
      fieldName: "status", 
      type: "status" 
    },
    { 
      header: "Time", 
      fieldName: "orderDate", 
      type: "date" 
    },
    { 
      header: "Actions", 
      fieldName: "actions", 
      type: "action", 
      actions: ["View", "View Prescription"],
      actionCallback: handleAction 
    }
  ];

  const filterRows: IHeaderRows[] = [
    {
      label: "Status",
      fieldName: "status",
      type: "dropdown",
      options: [
        { label: "All", value: "all" },
        { label: "Pending", value: "Pending" },
        { label: "Packed", value: "Packed" },
        { label: "Ready to dispatch", value: "Ready to dispatch" },
        { label: "Out for delivery", value: "Out for delivery" },
        { label: "Delivered", value: "Delivered" },
        { label: "cancelled", value: "cancelled" },
      ],
      operator: "eq",
      rowDivision: 3,
    }
  ];

  const handleSnackbarClose = useCallback(() => {
    setSnackbar({ open: false, message: '', severity: 'success' });
  }, []);

  if (loading) {
    return (
      <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
        <Grid item sm={12} display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <div>Loading recent prescription orders...</div>
        </Grid>
      </Grid>
    );
  }

  return (
  <>
    {/* HEADER SECTION */}
    <Grid
      container
      alignItems="center"
      justifyContent="space-between"
      sx={{
        px: 2,
        py: 2,
        backgroundColor: "#ffffff",
        borderRadius: "12px 12px 0 0",
      }}
    >
      <Grid item>
        <Typography fontSize={20} fontWeight={600}>
          Recent Prescription Order
        </Typography>
        {/* <Typography fontSize={14} color="text.secondary" mt={0.5}>
          Check your most recent prescription orders here.
        </Typography> */}
      </Grid>
    </Grid>

    {/* TABLE */}
    <Grid container spacing={2} sx={{ px: 1 }}>
      <Grid item sm={12}>
        <WSDataGridNew
          columns={columns}
          id="prescriptionOrderListGrid"
          data={prescriptionOrders}
          filterFields={filterRows}
          addButton={{ label: "New", color: "secondary" }}
          onAddButtonClick={handleAddClick}
          searchBox={{ fieldNames: ["orderId", "patientName"] }}
          gridHeaderSx={{
            backgroundColor: "whitesmoke",
            border: "1px solid whitesmoke",
          }}
        />
      </Grid>
    </Grid>

    {/* Snackbar */}
    <Snackbar
      open={snackbar.open}
      autoHideDuration={4000}
      onClose={handleSnackbarClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={handleSnackbarClose}
        severity={snackbar.severity}
        sx={{ width: "100%" }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  </>
);

});

export default RecentPrescriptionOrder;
